/* eslint-disable react/prop-types,no-shadow */
import React from 'react';
import { connect } from 'react-redux';
import { settingPageloading } from 'components/page/PageLoading/flow/action';
import Avator from '../component/avator';
import ChangePwd from '../component/changePwd';
import classNames from 'classnames/bind';
import { setAvator, updatePwd } from '../flow/action';
import { tryLogout } from 'views/LoginForm/flow/actions';

import styles from '../index.less';


const cx = classNames.bind(styles);

class GlobalSearch extends React.Component {
  render() {
    const {
      updatePwd, setAvator, userInfo, tryLogout, settingPageloading,
    } = this.props;
    return (<div className={cx('my-setting-wrapper')}>
      <div className={classNames(cx('avatar-wrapper'), 'pr-lg')}>
        <Avator userInfo={userInfo} setUserAvator={setAvator} settingPageloading={settingPageloading} />
      </div>
      <div className={cx('changepwd-wrapper')}>
        <ChangePwd submit={updatePwd} tryLogout={tryLogout} />
      </div>
            </div>);
  }
}
const mapStateToProps = ({ loginUser }) => ({
  userInfo: loginUser,
});
const mapDispatchToProps = {
  updatePwd,
  setAvator,
  tryLogout,
  settingPageloading,
};

export default connect(mapStateToProps, mapDispatchToProps)(GlobalSearch);



// WEBPACK FOOTER //
// ./src/views/MySetting/container/index.jsx